@for (bl of breadcrumbItems(); track $index; let last = $last) {
	<div>
		@if (bl.routerLink !== undefined) {
			<a [routerLink]="bl.routerLink" [ngClass]="{ active: last }">
				@if (bl.linkIcon) {
					<md-icon [icon]="bl.linkIcon"></md-icon>
				}
				@if (bl.linkText) {
					<span>{{ bl.linkText }}</span>
				}
			</a>
		} @else if (bl.component !== undefined) {
			<ng-container *ngComponentOutlet="bl.component; inputs: bl.componentInputs"></ng-container>
		} @else if (bl.linkText || bl.linkIcon) {
			<span class="crumb-text" [ngClass]="{ active: last }">
				@if (bl.linkIcon) {
					<md-icon [icon]="bl.linkIcon"></md-icon>
				}
				@if (bl.linkText) {
					<span>{{ bl.linkText }}</span>
				}
			</span>
		}
	</div>

	@if (!last) {
		<div class="chevron">
			<md-icon icon="untitled-ui/arrows/chevron-right"></md-icon>
		</div>
	}
}
